var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M970 744L970 772",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 970.5,
    cy: 739.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M965.987 739.19C965.987 735.283 969.288 732.117 973.358 732.117C973.943 732.117 974.511 732.184 975.056 732.308C973.742 731.48 972.187 731 970.519 731C965.814 731 962 734.806 962 739.5C962 744.194 965.814 748 970.519 748C972.814 748 974.895 747.093 976.427 745.62C975.492 746.032 974.454 746.263 973.358 746.263C969.288 746.263 965.987 743.096 965.987 739.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M979.402 738.6L979.37 736.146L977.535 737.719L975.304 737.056L976.112 739.337L974.765 741.381L977.1 741.218L978.499 743.144L979.133 740.763L981.345 739.909L979.402 738.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch2);
export default __webpack_public_path__ + "static/media/church_2.ec2fe6ee602131b7c273ce251c0fe4df.svg";
export { ForwardRef as ReactComponent };